import * as React from "react";
import {IconCircle} from "../../../../../../libs/components/libs/elements/icon.circle/index2";
import { FaCheck, FaTimes } from "react-icons/fa";

export const SettingsSuccessIndicator = () => <IconCircle size={16} className={"m-r-2"} icon={<FaCheck/>} iconSizeModifier={6} background={"complete"}/>;
export const SettingsInactiveIndicator = () => <IconCircle size={16} className={"m-r-2"} icon={<FaTimes/>} iconSizeModifier={6} background={"grey"}/>;
